import React, { PureComponent } from "react";

import { BarChart, Bar, XAxis, YAxis, ReferenceLine, Label } from "recharts";

import { Trend, selectFormat, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class PocketWatchGoals extends PureComponent {
  renderChart = (data) => (
    <BarChart
      height={200}
      width={160}
      barGap={10}
      data={data.chart}
      margin={{ top: 0, right: 55, left: 0, bottom: 40 }}
    >
      <defs>
        <linearGradient id={`color-${"#f87c5b"}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={"#f87c5b"} stopOpacity={0.55} />
          <stop offset="95%" stopColor={"#f87c5b"} stopOpacity={1} />
        </linearGradient>
        <linearGradient id={`color-${"#3D87C2"}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="5%" stopColor={"#3D87C2"} stopOpacity={0.55} />
          <stop offset="95%" stopColor={"#3D87C2"} stopOpacity={1} />
        </linearGradient>
      </defs>
      <Bar
        dataKey="current"
        fill={`url(#color-${"#f87c5b"})`}
        label={{
          position: "bottom",
          formatter: (value) => selectFormat(data.format, value),
          fontSize: 13,
          fontWeight: 700,
          fontFamily: "Museo Slab W01",
          offset: 10,
        }}
      />

      <Bar
        dataKey="prev"
        fill={`url(#color-${"#3D87C2"})`}
        label={{
          position: "bottom",
          formatter: (value) => selectFormat(data.format, value),
          fontSize: 13,
          fontWeight: 700,
          fontFamily: "Museo Slab W01",
          offset: 10,
        }}
      />

      <XAxis dataKey="date" hide />
      <YAxis hide padding={{ top: 10 }} />
      {data.goal ? (
        <ReferenceLine
          y={data.goal}
          strokeDasharray="2 2"
          stroke="#666"
          ifOverflow="extendDomain"
        >
          <Label
            value={data.goal}
            formatter={(value) => selectFormat(data.format, value)}
            fontSize={13}
            fontFamily={"Museo Slab W01"}
            position="right"
            fontWeight={700}
          />
        </ReferenceLine>
      ) : null}
    </BarChart>
  );

  renderContainers = (data) =>
    data.map((item, i) => (
      <div className="mb-5 col-6 col-md-6 col-lg mb-lg-0" key={i}>
        <Heading size={5} className={"mb-1"}>
          {item.label}
        </Heading>
        {this.renderChart(item)}
        {item.goal_change && item.goal_prior && (
          <div className="row">
            <div className="col-12">
              <Trend
                {...item.goal_change}
                label={
                  <div>
                    <div className="trend__name">
                      <small>
                        vs. <span className="text-dark-grey">goal</span>
                      </small>
                    </div>
                  </div>
                }
              />
            </div>

            <div className="col-12">
              <Trend
                {...item.goal_prior}
                label={
                  <div>
                    <div className="trend__name">
                      <small>
                        vs. <span className="text-blue"> prior</span>
                      </small>
                    </div>
                  </div>
                }
              />
            </div>
          </div>
        )}
      </div>
    ));

  renderLegends = () => (
    <div className="mb-4">
      <span className="mt-2 legend mt-md-0">
        <span className="legend__icon" style={{ background: "#f87c5b" }}></span>
        <span className="legend__text" style={{ color: "#f87c5b" }}>
          This Month
        </span>
      </span>
      <span className="mt-2 legend mt-md-0">
        <span className="legend__icon" style={{ background: "#3D87C2" }}></span>
        <span className="legend__text" style={{ color: "#3D87C2" }}>
          Prior Month
        </span>
      </span>
      <span className="mt-2 legend mt-md-0">
        <span className="legend__text" style={{ color: "#666" }}>
          <span className="legend__dash"></span> Goal
        </span>
      </span>
    </div>
  );

  render() {
    const { data } = this.props;
    // removes Unmonetized values task p2021-279
    data.data = data.data.filter((e) => e.label !== " % Unmonetized (Max)");

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row">
        <div className="col-12">{this.renderLegends()}</div>
        {this.renderContainers(data.data)}
      </div>
    );
  }
}

export default PocketWatchGoals;
